import React, { useContext } from 'react';
import GlobalContext from '../../utils/GlobalContext';

export default function MessageListContainer({
  children,
  isHaveNotice = false,
}) {
  const { locales } = useContext(GlobalContext);
  return (
    <div className="message-list-container">
      <div className="message-list-container__title">
        {isHaveNotice
          ? locales.common.notification
          : locales.common.noNewNotifications}
      </div>
      {children}
    </div>
  );
}
